import React from 'react'
import { PolylineF } from '@react-google-maps/api'
import BaiduPolyline from '@/component/map/baidu/BaiduPolyline'
import { useMapType } from '@/component/map/MapContext'
import { wgs84ToBd09 } from '@/util/coordTransform'

export interface UnifiedPolylineProps {
    path: { lat: number; lng: number }[]
    options?: {
        strokeColor?: string
        strokeOpacity?: number
        strokeWeight?: number
    }
}

const UnifiedPolyline: React.FC<UnifiedPolylineProps> = ({ path, options }) => {
    const { mapType } = useMapType()

    if (mapType === 'baidu') {
        const bdPath = path.map(p => {
            const [bdLat, bdLng] = wgs84ToBd09(p.lat, p.lng)
            return { lat: bdLat, lng: bdLng }
        })
        return <BaiduPolyline path={bdPath} options={options} />
    }

    return <PolylineF path={path} options={options} />
}

export default UnifiedPolyline
